import { createAction } from '@reduxjs/toolkit';

import { SearchParams } from 'src/api/searchApi';

export const fetchSearchList = createAction<SearchParams>('fetchSearchList');
